export { WalletPictogram } from './wallet-pictogram';
